export default __webpack_public_path__ + "static/media/progress_flowtys.c302e26f.png";